module.exports = __webpack_public_path__ + "static/media/gameLogo.4c706c41.png";